var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/CustomContentExtension.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { filter, switchMap } from "rxjs";
import { CustomContent } from "../../db/CustomContent.js";
import { BaseCustomContent } from "../../db/extensions/BaseCustomContent.js";
import { CustomContentConsumer, IdentifierConsumer } from "../globals/consumer.js";
import { Droppable } from "../globals/enums.js";
var CustomContentExtension = {
  class: CustomContent,
  renderReference(instance) {
    return html` <x-custom-content-reference .content=${instance}></x-custom-content-reference> `;
  },
  renderToolbarItems(renderItemMethod) {
    return html`
      <x-custom-content-toolbar-items .renderItemMethod=${renderItemMethod}></x-custom-content-toolbar-items>
    `;
  }
};
var XCustomContentToolbarItems = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._consumedIdentifier = IdentifierConsumer(this, true);
    this._customContent = CustomContentConsumer(this);
    this._customContentObservable = new RXController(
      this,
      void 0
    );
    this._customContents = new RXController(
      this,
      this._customContentObservable.observable.pipe(
        filter(Boolean),
        switchMap((customContent) => customContent.class.getAllActiveCustomContents()(customContent.class.allFields))
      )
    );
  }
  willUpdate(_changedProperties) {
    if (this._customContent.value && this._customContentObservable.value !== this._customContent.value) {
      this._customContentObservable.next(this._customContent.value);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.style.display = "contents";
  }
  render() {
    const customContents = this._customContents.value;
    const identifier = this._consumedIdentifier.value;
    if (!customContents || !customContents.length || !this.renderItemMethod || !identifier)
      return nothing;
    return html`
      ${repeat(
      customContents,
      (cc) => cc._id,
      (cc) => {
        return this.renderItemMethod?.(
          identifier,
          cc.isTemplate ? Droppable.CUSTOM_CONTENT_TEMPLATE : Droppable.CUSTOM_CONTENT_REFERENCE,
          cc.isTemplate ? cc.content : new BaseCustomContent({ referenceID: cc._id }),
          "flask",
          cc.name
        );
      }
    )}
    `;
  }
  createRenderRoot() {
    return this;
  }
};
__decorateClass([
  property({ attribute: false })
], XCustomContentToolbarItems.prototype, "renderItemMethod", 2);
__decorateClass([
  state()
], XCustomContentToolbarItems.prototype, "_consumedIdentifier", 2);
__decorateClass([
  state()
], XCustomContentToolbarItems.prototype, "_customContent", 2);
__decorateClass([
  state()
], XCustomContentToolbarItems.prototype, "_customContentObservable", 2);
__decorateClass([
  state()
], XCustomContentToolbarItems.prototype, "_customContents", 2);
XCustomContentToolbarItems = __decorateClass([
  customElement("x-custom-content-toolbar-items")
], XCustomContentToolbarItems);
export {
  CustomContentExtension,
  XCustomContentToolbarItems
};
